import React, { Component } from 'react';
import tableDragger from 'table-dragger';
import Modal from 'react-responsive-modal';
import swal from 'sweetalert';
import { baseUrl } from '../../Comman/apiEndPoints';
import imageCompression from 'browser-image-compression';
import { withNamespaces } from 'react-i18next';
import InputWithExtra from '../../Comman/components/InputWithExtra';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
// import { Editor } from "react-draft-wysiwyg";
// import { EditorState } from "draft-js";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const options = {
    maxSizeMB: 2.0,          // (default: Number.POSITIVE_INFINITY)
    maxWidthOrHeight: 600,   // compressedFile will scale down by ratio to a point that width or height is smaller than maxWidthOrHeight (default: undefined)
    useWebWorker: true,      // optional, use multi-thread web worker, fallback to run in main-thread (default: true)
    maxIteration: 10        // optional, max number of iteration to compress the image (default: 10)
}
const sleep = (milliseconds) => {
    return new Promise(resolve => setTimeout(resolve, milliseconds))
}
var result_arr = [];
class PermissionsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // editorState : EditorState.createEmpty(),
            openModal: false,
            image: null,
            isEdit: false,
            ID: 0,
            newPermissionsData: {
                PermissionKey: '',
                Permission: '',
                Category: 'Admin'
            }
        }
        this.handleInput = this.handleInput.bind(this);
        this.actionColumn = this.actionColumn.bind(this);
        this.add=this.add.bind(this);
    }

    actionColumn(item) {
        const { t } = this.props;
        return (
            <span>
                <button type="button" className="btn btn-primary edit-carousel"
                    onClick={this.openEditModal.bind(this, item)}>{t('Alarm Setting.Edit')}</button>
                <button type="button" className="btn btn-primary"
                    onClick={this.delete.bind(this, item.ID)}>{t('First_Responder.Delete')}</button>

            </span>
        )
    }
    componentWillReceiveProps(nextProps) {
        // console.log("next",nextProps)
        if (nextProps.PermissionsDetails.statusCode !== this.props.PermissionsDetails.statusCode) {

            if (nextProps.PermissionsDetails.statusCode == 201) {
                this.errornotify(nextProps.PermissionsDetails.message);
                // this.props.getList();
            }
        }

    }

    errornotify = (message) => {
        // toast.error(message + "!", {
        //     position: toast.POSITION.TOP_CENTER
        // });
        swal({ text: message, icon: 'error' })

    };
    openModal = () => {
        this.setState({ openModal: true })
    }
    closeModal = () => {
        this.setState({ openModal: false })
        this.setState({ isEdit: false, image: null })
        this.setState({
            newPermissionsData: {
                PermissionKey: '',
                Permission: '',
                Category: ''
            }
        })
    }
    handleInput = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        this.setState(prevState => ({
            newPermissionsData:
                { ...prevState.newPermissionsData, [name]: value }
        }),)
        // sleep(3000).then(() => {
        //     console.log("setstate",this.state);
        // })
    }

    delete(id) {
        const { t } = this.props;
        console.log("data", id);
        swal({
            title: `${t('Permissions.Delete Permissions')}`,
            text: `${t('Permissions.Are you sure you want to delete this Permissions')}?`,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    let payload={
                        ID:id,
                        DeletedBy:sessionStorage.getItem('SuperAdminUserID')
                        
                    }
                    this.props.deletePermissionsItem(payload);
                    setTimeout(
                        () => this.props.getPermissionsList(),
                        400
                    );
                } else {
                    swal(`${t('Carousel Setting.Data not deleted')}`);
                }
            });
    }
    add = () => {
        const { t } = this.props;
        if (this.state.newPermissionsData.PermissionKey.length > 0 && this.state.newPermissionsData.Permission.length > 0) {
            var formData = {
                'ID': 0,
                'PermissionKey': this.state.newPermissionsData.PermissionKey,
                'Permission': this.state.newPermissionsData.Permission,
                'Category':this.state.newPermissionsData.Category,
                'CreatedBy': sessionStorage.getItem('SuperAdminUserID')
            }
            this.props.addPermissions(formData);
            this.setState({ openModal: false, image: null })
            this.setState({
                newPermissionsData: {
                    Permissionkey: '',
                    Permission: '',
                    Category: ''
                }
            })
            setTimeout(
                () => this.props.getPermissionsList(),
                400
            );

        }
        else {
            this.state.newPermissionsData.Permission.length == 0 ? swal(`${t('Permissions.Please Enter Permissions')}`) : swal(`${t('Permissions.Please Enter Permissions Key')}`);
        }
    }
    update = () => {
        const { t } = this.props;
        var formData = {
            'ID': this.state.ID,
            'PermissionKey': this.state.newPermissionsData.PermissionKey,
            'Permission': this.state.newPermissionsData.Permission,
            'Category': this.state.newPermissionsData.Category,
            'CreatedBy': sessionStorage.getItem('SuperAdminUserID')
        }



        if (this.state.ID > 0 && this.state.newPermissionsData.Permission && this.state.newPermissionsData.PermissionKey) {
            this.props.updatePermissions(formData);

            this.setState({
                newPermissionsData: {
                    PermissionKey: '',
                    Permission: '',
                    Category: ''
                }
            })
           this.closeModal()
            setTimeout(
                () => this.props.getPermissionsList(),
                400
            );
        }
       else {
            this.state.newPermissionsData.Permission.length == 0 ? swal(`${t('Permissions.Please Enter Permissions')}`) : swal(`${t('Permissions.Please Enter Permissions Key')}`);
        }
    }
    formatCreatedDate(rowData) {
        if (rowData.CreatedDate != null && rowData.CreatedDate != undefined) {
            if (rowData.CreatedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.CreatedDate.split('T');

                let data = value[1].split(':');
                let sec = data[2].split('.')
                return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
            }
        }
    }
    formatUpdatedDate(rowData) {
        if (rowData.UpdatedDate != null && rowData.UpdatedDate != undefined) {
            if (rowData.UpdatedDate == "0001-01-01T00:00:00") {
                return;
            }
            else {
                let value = rowData.UpdatedDate.split('T');
                let data = value[1].split(':');
                let sec = data[2].split('.')
                return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
            }
        }
    }
    openEditModal = (item) => {
        this.setState({
            isEdit: true,
            ID: item.ID,
            // image : item.PageLogo,
            newPermissionsData: {
                PermissionKey: item.PermissionKey,
                Permission: item.Permission,
                Category:item.Category
            }
        })
    }


    //   onEditorStateChange = (editorState) => {
    //     this.setState({
    //       editorState : editorState
    //     });
    //     console.log("setstate1",this.state);
    //   };
    render() {
        const { t } = this.props;
        var refreshButtonData = <span>
            <button onClick={this.openModal} style={{ outline: 'none', border: 'none' }} type="button" className="notification-badge btn btn-primary">{t('Permissions.Add')}<span className="badge bg-secondary"></span></button>

        </span>
        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div className="container carousel-page">

                <div className="progressbar-heading grids-heading">
                    <h2>{t('Permissions.Permissions List')}</h2>
                </div>
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                {refreshButtonData}
                                <div className="w3l_search">

                                    {header}
                                </div>
                                {/* <div className="w3l_search">
                                                <button style={{ marginLeft: '60%',marginTop:'-2rem',outline:'none',border:'none' }} type="button"  class="notification-badge btn btn-primary">Refresh<span class="badge bg-secondary"></span></button>
                
                                                   
                                                </div> */}

                                <div className="devicestable">
                                    <br />

                                    <DataTable
                                        className="table"
                                        value={this.props.PermissionsDetails.permissionsList}
                                        //loading={this.props.incomingAlarmList.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}
                                        // rowClassName={this.rowClassName}

                                        emptyMessage={t('Feedback Setting.No records found')}>
                                        <Column field="Permission" header={t('Permissions.Permissions')} sortable={true} className="wordBreakLine" />
                                        <Column field="PermissionKey" header={t('Permissions.Permissions Key')} sortable={true} className="wordBreakLine" />
                                        <Column field="Category" header={t('Permissions.Permissions Category')} sortable={true} className="wordBreakLine" />

                                        <Column field="CreatedDate" body={this.formatCreatedDate} header={t('Permissions.Created Date')} sortable={true} />
                                        <Column field="UpdatedTime" body={this.formatUpdatedDate} header={t('Permissions.Updated Date')} sortable={true} />
                                        <Column headerClassName="hideheader" body={this.actionColumn} header={t('First_Responder.Action')} />
                                    </DataTable>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <Modal open={this.state.openModal} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('Permissions.Add Permissions')}</h2>
                        </div>
                        <div className="forms add-device setting-panel">
                            <div className="form-three widget-shadow">
                                <div className=" panel-body-inputin">
                                    <form className="form-horizontal modalForm">
                                        {/* <div className="form-group">
                                            <label className="col-sm-3 control-label">
                                                Page Sequence
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="number"
                                                    id="PageSequence"
                                                    name={'PageSequence'}
                                                    value={this.state.newCarouselData.PageSequence}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div> */}
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Permissions.Permission')}</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="Permission"
                                                    name={'Permission'}
                                                    value={this.state.newPermissionsData.Permission}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Permissions.Permission key')}</label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    id="PermissionKey"
                                                    name={'PermissionKey'}
                                                    value={this.state.newPermissionsData.PermissionKey}
                                                    className="form-control1"
                                                    onChange={this.handleInput}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-sm-3 control-label">{t('Permissions.Permissions Category')}</label>
                                            <div className="col-sm-9">
                                                <select id="PermissionsCat" className="form-control1"
                                                    onChange={this.handleInput}
                                                    value={this.state.newPermissionsData.Category}
                                                    placeholder="Select"
                                                    ref="PermissionsCat"
                                                    name={'Category'}
                                                >
                                                    <option value={'Superadmin'} key={'Superadmin'}>Superadmin</option>
                                                    <option value={'Admin'} key={'Admin'}>Admin</option>

                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <div className="col-sm-offset-5 col-sm-6">
                                                <p>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary general-btn"
                                                        onClick={this.add}
                                                    >
                                                        {t('Alarm Setting.Save')}
                                                    </button>
                                                </p>
                                            </div>
                                        </div>
                                    </form></div></div></div>
                    </div>
                </Modal>
                <Modal open={this.state.isEdit} onClose={this.closeModal} center>
                    <div className="modal1 alarmsetmodal">
                        <div className="progressbar-heading grids-heading">
                            <h2>{t('Permissions.Edit Permissions')}</h2>
                        </div>
                    </div>
                    <div className="forms add-device setting-panel">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">
                                <form className="form-horizontal modalForm">
                                    <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('Permissions.Permission')}</label>
                                        <div className="col-sm-9">
                                            <InputWithExtra
                                                type="text"
                                                id="Permission"
                                                name={'Permission'}
                                                value={this.state.newPermissionsData.Permission}
                                                className="form-control1 FR-edit-details"
                                                onChange={this.handleInput}
                                            />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('Permissions.Permissions Key')}</label>
                                        <div className="col-sm-9">
                                            <InputWithExtra type="text" id="PermissionKey" name={'PermissionKey'} className="form-control1 FR-edit-details"
                                                value={this.state.newPermissionsData.PermissionKey} onChange={this.handleInput} />
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label className="col-sm-3 control-label">{t('Permissions.Permissions Category')}</label>
                                        <div className="col-sm-9">
                                            <select disabled id="PermissionsCat" className="form-control1 FR-edit-details" style={{marginLeft:'16px'}}
                                                onChange={this.handleInput}
                                                value={this.state.newPermissionsData.Category}
                                                placeholder="Select"
                                                ref="PermissionsCat"
                                                name={'Category'}
                                            >
                                                <option value={'Superadmin'} key={'Superadmin'}>Superadmin</option>
                                                <option value={'Admin'} key={'Admin'}>Admin</option>

                                            </select>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="col-sm-offset-5 col-sm-6">
                                            <p>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary general-btn"
                                                    onClick={this.update}
                                                >
                                                    {t('Alarm Setting.Save')}
                                                </button>
                                            </p>
                                        </div>
                                    </div>
                                </form></div></div></div>
                </Modal>
                {/* <Editor
          editorState={this.state.editorState}
          onEditorStateChange={this.onEditorStateChange}
        /> */}
            </div>
        )
    }
}
export default withNamespaces()(PermissionsComponent);